import { NgModule } from '@angular/core';
import {NebulaTailwindService} from '@scientifica-cms-fe/services/tailwind/tailwind.service';

@NgModule({
    providers: [
        NebulaTailwindService
    ]
})
export class NebulaTailwindConfigModule
{
    /**
     * Constructor
     */
    constructor(private _nebulaTailwindConfigService: NebulaTailwindService)
    {
    }
}
